module.exports = __webpack_public_path__ + "img/C03TechRamChampion_ua.10d46849.webp";